import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import {
  AuthInfiniteQueryOptions,
  AuthQueryOptions,
  UnauthInfiniteQueryOptions,
  UnauthQueryOptions,
} from '@/api/v2';

interface HometownNewsFeedbackOptionsProps {
  id: number | undefined;
  isLogin?: boolean;
}

interface HometownNewsListOptionsProps {
  keyword?: string;
  codeRegion?: string;
  codeSubRegion?: string;
  isLogin: boolean | undefined;
  hometownNewsSort?: 'LATEST' | 'POPULARITY';
}

export const hometownNewsQueryOptions = {
  list: ({
    keyword,
    isLogin,
    codeRegion,
    codeSubRegion,
    hometownNewsSort = 'LATEST',
  }: HometownNewsListOptionsProps) => {
    const INITIAL_PAGE = 1;
    const PAGE_SIZE = 20;

    return infiniteQueryOptions({
      ...(isLogin
        ? AuthInfiniteQueryOptions['get:/wello/v2/auth/hometown-news']
        : UnauthInfiniteQueryOptions['get:/wello/v2/allows/hometown-news'])({
        query: {
          page: INITIAL_PAGE,
          size: PAGE_SIZE,
          code_region: codeRegion,
          code_sub_region: codeSubRegion,
          hometown_news_sort: hometownNewsSort,
          search_keyword: keyword,
        },
      }),
      enabled: isLogin !== undefined,
      select: (data) => ({
        pages: data.pages.map(({ context }) => ({
          contents: context?.contents?.map((news) => {
            return {
              id: news.hometown_news_id,
              idIdx: news.hometown_news_id_idx,
              title: news.hometown_news_name,
              daysAgo: news.days_ago,
              thumbnail: news.thumbnail,
              commentCount: news.comment_count,
              isBookmarked: news.wishlist_yn,
              bookmarkCount: news.wishlist_count,
              dateText: news.published_at,
              summary: news.summary,
              thumbUpCount: news.like_count,
              isThumbUp: news.like_yn,
            };
          }),
          totalCount: context?.total_count,
        })),
        pageParams: data.pageParams,
      }),
      getNextPageParam: (lastPage) => {
        if (lastPage.context?.total_count && lastPage.context.page) {
          const nextPage = lastPage.context.page + 1;
          const maxPage = Math.ceil(lastPage.context.total_count / PAGE_SIZE);

          return nextPage <= maxPage ? nextPage : undefined;
        }
      },
      initialPageParam: INITIAL_PAGE,
    });
  },
  feedback: ({ id, isLogin }: HometownNewsFeedbackOptionsProps) =>
    queryOptions({
      ...(isLogin
        ? AuthQueryOptions[
            'get:/wello/v2/auth/hometown-news/feedback/{hometown_news_id}'
          ]
        : UnauthQueryOptions[
            'get:/wello/v2/allows/hometown-news/feedback/{hometown_news_id}'
          ])({
        path: {
          hometown_news_id: id!,
        },
      }),
      enabled: isLogin !== undefined && !!id,
    }),
};
